import React from "react";
import Organizations from "./Organizations";

export const HomePage = () => {
    return <Organizations/>
};
